<script lang="ts" setup>
import { useForm } from '../state'
import Form from './Form.vue'

const { strings, start, props } = useForm()
</script>

<template>
  <div class="h-full gap-inherit grid grid-cols-1 grid-rows-[auto_1fr_auto] xxs:grid-cols-2 xxs:grid-rows-[1fr_auto]" :class="{ '!grid-cols-1 !grid-rows-[1fr_auto]': props.minimal }">
    <div v-if="!props.minimal" class="card md:row-span-2 gap-15px flex-col-center text-center">
      <h2
        class="font-semibold leading-none text-xl text-$color-primary xxs:text-32px sm:text-48px md:text-64px"
        v-text="strings.headerTitle"
      />
      <span class="text-base sm:text-24px opacity-60" v-text="strings.headerSubtitle" />
    </div>

    <div class="card-outline w-full flex-col-center">
      <IconButton class="icon-button" variant="primary" size="lg" icon="i-solar-microphone-2-bold" aria-label="Start Recording" @click="start" />
      {{ strings.startRecording }}
    </div>

    <Form />
  </div>
</template>
